/**
 * Zapfeed integrations API (https://feedback.scriptix.io/api/integrations).
 * Only the fields the Bug Board widget renders are typed here; the API
 * returns more per post.
 */

export type ZapfeedPostType =
  | 'BUG'
  | 'FEATURE'
  | 'FEEDBACK'
  | 'QUESTION'
  | 'OTHER';

export type ZapfeedPostStatus =
  | 'NEW'
  | 'OPEN'
  | 'UNDER_REVIEW'
  | 'PLANNED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'DECLINED'
  | 'CLOSED';

export type ZapfeedPostPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';

export interface ZapfeedBoard {
  id: string;
  name: string;
  slug: string;
  color?: string | null;
  icon?: string | null;
}

export interface ZapfeedPost {
  id: string;
  title: string;
  description: string;
  type: ZapfeedPostType;
  status: ZapfeedPostStatus;
  priority: ZapfeedPostPriority;
  voteCount: number;
  createdAt: string;
  updatedAt: string;
  board: ZapfeedBoard | null;
  user: { id: string; name: string | null; email: string | null } | null;
  _count?: { comments: number; votes: number };
}

export interface ZapfeedPostsResponse {
  posts: ZapfeedPost[];
  nextCursor: string | null;
}

/** Statuses that still need triage or work, in the order the widget shows them. */
export const ZAPFEED_OPEN_STATUSES: ZapfeedPostStatus[] = [
  'NEW',
  'OPEN',
  'UNDER_REVIEW',
  'PLANNED',
  'IN_PROGRESS'
];
